module.exports = __webpack_public_path__ + "img/ch14_05_喂鸡鸡飞上头.98d4c6dc.jpg";